import LightBox from './LightBox'

export default LightBox
